export default {
  Billing: "Billing",
  AddBilling: "AddBilling",
  editBilling: "EditBilling"
};
